export default __webpack_public_path__ + "static/media/mail.b4285510.svg";